import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IAugmentedJQuery, IController, IFormController, IModule, INgModelController, IOnChangesObject, IPromise, ITimeoutService} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import _ from "lodash";
import {gettextCatalog} from "angular-gettext";
import {dersomChangesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import {MøteTjeneste, Møtevalideringsfeil} from "web/moduler/møte/MøteTjeneste";
import {Tidssonevalg} from "../../../../../felles/tjenester/i18n/Tidssonevalg";
import moment from "moment";
import {Datoer, erGyldigDatoinstans} from "../../../../../felles/tjenester/Datoer";
import {Debugger} from "debug";
import {klokkeslett5MinIntervaller, varigheter5MinIntervaller, VarigheterInnslag} from "felles/stoettefunk/datoer";
import {erIkkeNill} from "felles/stoettefunk/nillsjekk";
import {Møtedatoer} from "felles/tjenester/møte/Møtedatoer";

require('./redigerMøtetidspunkt.scss');

const debug: Debugger = require('debug')('RedigerMøtetidspunkt');

export class RedigerMøtetidspunkt implements IController {

    static registrerKomponent(angular: IModule) {
        angular.component('wmRedigerMoetetidspunkt', {
            bindings: {
                gruppe: '<',
                moetedato: '<',
                tillattStartdatoPeriode: '<?',
                standardVarighet: '<?',
                standardStarttidspunkt: '<?',
                skjema: '<',
                valider: '&?',
                vedOpprettAarsplan: '&?'
            },
            controller: RedigerMøtetidspunkt.forInjisering(),
            template: require('./redigerMøtetidspunkt.html')
        });
    }

    static forInjisering() {
        return [
            regNavn.ng.$element,
            regNavn.ng.$timeout,
            MøteTjeneste.regNavn,
            Tidssonevalg.regNavn,
            regNavn.gettext.gettextCatalog,
            RedigerMøtetidspunkt
        ]
    }

    constructor(private $element: IAugmentedJQuery,
                private $timeout: ITimeoutService,
                private møteTjeneste: MøteTjeneste,
                private tidssonevalg: Tidssonevalg,
                private gettextCatalog: gettextCatalog) {
        this.tidssone = tidssonevalg.aktivTidssoneAbbr();
    }

    gruppe: l.GruppeModell; //settes via bindings/$onChanges
    moetedato: l.MøteDato; //settes via bindings/$onChanges
    tillattStartdatoPeriode: l.PlanPeriode; //settes via bindings/$onChanges
    standardVarighet: number; //settes via bindings/$onChanges
    standardStarttidspunkt: string; //settes via bindings/$onChanges
    skjema: IFormController; //settes via bindings
    valider: (args: { dato: l.MøteDato }) => IPromise<Møtevalideringsfeil>; //satt via bindings
    vedOpprettAarsplan: (args: {gruppeId:string; periode:l.PlanPeriode}) => void; //settes via bindings, merk at denne er ikke null selvom attributtet ikke er angitt

    modell: OppdaterMøtetidspunktSkjemaModell = null;
    tidssone: string;

    oppdater(){
        this.validerMøtedato();

        let dato = this.modell.somMøtedato();
        if (_.isNil(dato)) return;
        debug("oppdaterer moetedato", dato)
        this.moetedato.start = dato.start;
        this.moetedato.slutt = dato.slutt;
    }

    opprettAarsplan() {
        //merk at vi her antar at årsplaner dekker hele år - håndtere ikke at eventuell foregående plan ikke slutter på 31.12
        let dato = this.modell.startdato
        const start = moment(dato).utc(true).startOf('year').toDate();
        const slutt = moment(start).utc(true).endOf('year').toDate();
        this.vedOpprettAarsplan({gruppeId: this.gruppe.id, periode: {start: start, slutt: slutt}});
    }

    $onInit(): void {
        //sørger for å sette markør i dato-feltet slik at dette bli rød-merket dersom dato ikke satt
        this.$timeout(() => this.$element.find('.md-datepicker-input').focus(), 500);
    }

    $onChanges(changes: IOnChangesObject) {
        dersomChangesInneholder(changes, 'moetedato',
            dato => this.modell = OppdaterMøtetidspunktSkjemaModell.nyOppdaterMøtetidspunktSkjemaModell(this.moetedato, this.tillattStartdatoPeriode, this.standardStarttidspunkt, this.standardVarighet, this.gettextCatalog));
        dersomChangesInneholder(changes, 'gruppe', gruppeId => {
            if (_.isNil(this.modell)) return; //må vente til modell har blitt init
            this.validerMøtedato();
        });
        dersomChangesInneholder(changes, 'standardVarighet',
            dato => {
                if (_.isNil(this.modell)) return; //må vente til modell har blitt init
                this.modell.oppdaterStandardVarighet(this.standardVarighet);
                this.oppdater();
            });
        dersomChangesInneholder(changes, 'standardStarttidspunkt',
            dato => {
                if (_.isNil(this.modell)) return; //må vente til modell har blitt init
                this.modell.oppdaterStandardStarttidspunkt(this.standardStarttidspunkt);
                this.oppdater();
            });
    }

    //hjelpemetoder

    private validerMøtedato() {
        const datoFelt: INgModelController = this.skjema['moetedato'];
        let dato = this.modell.datoForValidering();

        if (_.isNil(datoFelt)) return; //vi kan bli kalt før skjema har blitt populert
        if (_.isNil(dato)) return;
        if (_.isNil(this.gruppe)) return;
        if (_.isNil(this.valider)) return;

        this.valider({dato: dato})
            .then(valideringsfeil => this.modell.oppdaterValideringsresultat(valideringsfeil, datoFelt));
    }

}

export class OppdaterMøtetidspunktSkjemaModell {
    visIngenPlanMelding = false;
    //relevant for ett- og flerdags-møte
    flerdagsmoete = false;
    startdato: Date;
    starttidspunkt: string;
    starttidspunkter: string[];
    tillattStartdatoPeriode: l.PlanPeriode;
    //relevant for ettdags-møte
    varigheter: VarigheterInnslag[];
    varigheterFlerdagsmoeteInnslag: VarigheterInnslag = {navn: 'flerdagsmøte', verdi: -1};
    varighet: VarigheterInnslag;
    private initiellVarighet: VarigheterInnslag;
    //relevant for flerdags-møte
    sluttdato: Date;
    slutttidspunkt: string;

    static nyOppdaterMøtetidspunktSkjemaModell(møtedato: l.MøteDato, tillattStartdatoPeriode: l.PlanPeriode, standardStarttidspunkt:string, standardVarighet:number, gettextCatalog: gettextCatalog): OppdaterMøtetidspunktSkjemaModell {
        debug("nyOppdaterMøtetidspunktSkjemaModell, møtedato: %j", møtedato, standardStarttidspunkt, standardVarighet);
        //av ukjent grunn blir denne kalt med møtedato.start == invalid date - skjer dersom man har angitt start-tidspunkt og varighet, men ikke dato, skifter til "saker" i opprett møte-dialog, så skifter tilbake til "møtedetaljer"
        if (!erGyldigDatoinstans(møtedato.start)) møtedato.start = null;
        if (!erGyldigDatoinstans(møtedato.slutt)) møtedato.slutt = null;

        var modell = new OppdaterMøtetidspunktSkjemaModell();

        modell.tillattStartdatoPeriode = tillattStartdatoPeriode;
        modell.startdato = møtedato.start ? new Date(møtedato.start) : null; //<md-datepicker md-min/max-date attributtene ser ut til å endre Dato-objektet - derfor ny Date
        modell.starttidspunkter = klokkeslett5MinIntervaller();
        modell.starttidspunkt = møtedato.start ? moment(møtedato.start).format("HH:mm") : standardStarttidspunkt;
        modell.varigheter = varigheter5MinIntervaller(gettextCatalog);
        modell.flerdagsmoete = Møtedatoer.erFlerdagsmøte(møtedato);
        if (modell.flerdagsmoete) {
            modell.sluttdato = møtedato.slutt ? new Date(møtedato.slutt) : null; //<md-datepicker md-min/max-date attributtene ser ut til å endre Dato-objektet - derfor ny Date
            modell.slutttidspunkt = møtedato.slutt ? moment(møtedato.slutt).format("HH:mm") : null;
            modell.varighet = _(modell.varigheter).find(varighet => varighet.verdi == 60); //1 time som default - benyttes dersom man bytter fra flerdags til en-dags-møte
            modell.initiellVarighet = modell.varighet;
        } else {
            var varighetIMinutter = møtedato.start && møtedato.slutt ? moment.duration(møtedato.slutt.getTime() - møtedato.start.getTime()).asMinutes() : standardVarighet;
            modell.varighet = _(modell.varigheter).find(varighet => varighet.verdi == varighetIMinutter);
            modell.initiellVarighet = modell.varighet;
            modell.sluttdato = møtedato.slutt ? moment(møtedato.slutt).add(1, 'days').toDate() : null;
            modell.slutttidspunkt = møtedato.slutt ? moment(møtedato.slutt).format("HH:mm") : null;
        }
        return modell;
    }

    oppdaterStandardVarighet(standardVarighet: number) {
        debug("oppdaterStandardVarighet", standardVarighet, this)
        if (erIkkeNill(this.startdato)) return;
        this.varighet = _(this.varigheter).find(varighet => varighet.verdi == standardVarighet);
    }

    oppdaterStandardStarttidspunkt(standardStarttidspunkt: string) {
        debug("oppdaterStandardStarttidspunkt", standardStarttidspunkt, this)
        if (erIkkeNill(this.startdato)) return;
        this.starttidspunkt = standardStarttidspunkt;
    }

    varighetEndret() {
        if (this.varighet == this.varigheterFlerdagsmoeteInnslag) {
            this.flerdagsmoete = true;
            this.varighet = this.initiellVarighet;
            return;
        }
        this.initiellVarighet = this.varighet;
    }

    datoEndret() {
        if (!this.flerdagsmoete) return;
        debug('datoEndret', this.startdato, this.sluttdato)
        if (this.startdato?.getDate() == this.sluttdato?.getDate())
            this.flerdagsmoete = false;
    }

    //  filtrerStarttidspunkter(filter:string){
    //      console.log("filtrerStarttidspunkter", filter)
    //      if (_.isEmpty(filter) ) return this.starttidspunkter;
    //      var filterlowercase = filter.toLowerCase();
    //      return this.starttidspunkter.filter(kandidat => kandidat.indexOf(filterlowercase) === 0)
    //  }
    //  filtrerVarigheter(filter:string){
    //      if (_.isEmpty(filter) ) return this.varigheter;
    //      var filterlowercase = filter.toLowerCase();
    //      return this.varigheter.filter(kandidat => kandidat.navn.indexOf(filterlowercase) === 0)
    //  }

    datoForValidering():l.MøteDato{
        if (_.isNil(this.startdato)) return null;
        const dato = this.somMøtedato() || {start:null, slutt: null};
        //dersom start ikke er angitt setter vi denne til startdato kl12
        if (_.isNil(dato.start)) dato.start = Datoer.datoMedKlokkeslett(this.startdato, '12:00');
        //dersom slutt ikke er angitt denne til start + 1 time
        if (_.isNil(dato.slutt)) dato.slutt = moment(dato.start).add(1, 'hour').toDate();
        return dato;
    }

    oppdaterValideringsresultat(valideringsfeil: Møtevalideringsfeil, datoFelt: INgModelController){
        datoFelt.$setValidity("overlapper", valideringsfeil !== Møtevalideringsfeil.overlappendeMoete);
        datoFelt.$setValidity("sluttFoerStart", valideringsfeil !== Møtevalideringsfeil.sluttFoerStart);
        datoFelt.$setValidity("protokollLaast", valideringsfeil !== Møtevalideringsfeil.protokollLaast);
        this.visIngenPlanMelding = valideringsfeil === Møtevalideringsfeil.ingenPlan;
    }

    somMøtedato(): l.MøteDato {
        if (_.isNil(this.startdato) || _.isNil(this.starttidspunkt)) return null;
        if (this.flerdagsmoete){
            if (_.isNil(this.sluttdato) || _.isNil(this.slutttidspunkt)) return null;
        } else
        if (_.isNil(this.varighet)) return null;

        var start = Datoer.datoMedKlokkeslett(this.startdato, this.starttidspunkt);
        var slutt = this.flerdagsmoete ?
            Datoer.datoMedKlokkeslett(this.sluttdato, this.slutttidspunkt) :
            moment(start).add("minutes", this.varighet.verdi).toDate();

        return {start: start, slutt: slutt};
    }

}
